import React from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import featuredImage from "../../../assets/PogfortsHome.png";
import titleImage from "../../../assets/TitleUpvote.png";

const Home = () => {
    const baseURL = window.location.origin; // This automatically changes for localhost and production

    return (
        <div className="home-container">

            {/* SEO Meta Tags for Social Media Sharing */}
            <Helmet>
                <title>Pogforts - MMM Discord Server</title>
                <meta name="description" content="Details of all usable items at Pogforts." />
                <meta property="og:title" content="Items - Entire Inventory" />
                <meta property="og:description" content="Details of all usable items at Pogforts." />
                <meta property="og:image" content={`${baseURL}/assets/PogfortsHome.png`} />
                <meta property="og:url" content={`${baseURL}/items`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Items - Entire Inventory" />
                <meta name="twitter:description" content="Details of all usable items at Pogforts." />
                <meta name="twitter:image" content={`${baseURL}/assets/PogfortsHome.png`} />
            </Helmet>

            {/* Hidden H1 Title for SEO but invisible to users */}
            <h1 className="hidden-title">Items - Entire Inventory</h1>

            <img src={titleImage} alt="TitleUpvote" className="featured-image" />
            
            {/* Featured Image Below Title */}
            <img src={featuredImage} alt="Pogforts" className="featured-image" />

            <p>Welcome to Pogforts!</p>
        </div>
    );
};

export default Home;
